<article
  class="v3-content-card"
  [class.v3-content-card--list]="isList()"
  [class.v3-content-card--accent-teal]="item().accent === 'teal'"
  [attr.data-card-uid]="item().uid"
>
  @if (!editActions()) {
    <button type="button" class="v3-content-card__main-link" [attr.aria-label]="item().title" (click)="onCardClick()"></button>
  }

  <div class="v3-content-card__cover" [class.has-save]="showSave()" [style.background]="coverBackground()">
    @if (hasThumbnail()) {
      <img class="v3-content-card__cover-image" [src]="item().thumbnail" [alt]="item().title" />
    } @else if (item().coverIcon) {
      <span class="v3-content-card__cover-icon" aria-hidden="true">
        <svg [lucideIcon]="item().coverIcon!" [size]="20"></svg>
      </span>
    }
    @if (overdueBadge(); as badge) {
      <span class="v3-content-card__cover-badge v3-content-card__cover-badge--overdue">
        @if (badge.icon) {
          <svg [lucideIcon]="badge.icon" [size]="11"></svg>
        }
        {{ badge.text }}
      </span>
    }
    @if (coverBadge(); as badge) {
      <span class="v3-content-card__cover-badge">
        @if (badge.icon) {
          <svg [lucideIcon]="badge.icon" [size]="11"></svg>
        }
        {{ badge.text }}
      </span>
    }
    @if (!isList() && item().typeLabel) {
      <span class="v3-content-card__type-chip">
        @if (item().typeIcon) {
          <svg [lucideIcon]="item().typeIcon!" [size]="12"></svg>
        }
        {{ item().typeLabel }}
      </span>
    }
    @if (showSave()) {
      <button
        type="button"
        class="v3-content-card__save"
        [class.is-saved]="saved()"
        [attr.aria-label]="saveLabel() || null"
        [attr.aria-pressed]="saved()"
        (click)="onSaveClick()"
      >
        <svg [lucideIcon]="LucideBookmark" [size]="16"></svg>
      </button>
    }
    @if (editActions()) {
      <span class="v3-content-card__edit-actions">
        <button
          type="button"
          class="v3-content-card__edit-btn"
          [attr.aria-label]="'translations.global.button.edit' | transloco"
          (click)="onEditClick()"
        >
          <svg [lucideIcon]="LucidePencil" [size]="14"></svg>
        </button>
        @if (deletable()) {
          <button
            type="button"
            class="v3-content-card__edit-btn v3-content-card__edit-btn--delete"
            [attr.aria-label]="'translations.global.button.remove' | transloco"
            (click)="onDeleteClick()"
          >
            <svg [lucideIcon]="LucideTrash2" [size]="14"></svg>
          </button>
        }
      </span>
    }
  </div>

  <div class="v3-content-card__body">
    @if (showBadgeRow()) {
      <div class="v3-content-card__badges">
        @if (isList() && item().typeLabel) {
          <span class="v3-content-card__type-badge">
            @if (item().typeIcon) {
              <svg [lucideIcon]="item().typeIcon!" [size]="12"></svg>
            }
            {{ item().typeLabel }}
          </span>
        }
        @if (item().statusBadge; as badge) {
          <span class="v3-content-card__status-badge" [attr.data-tone]="badge.tone">
            @if (badge.icon) {
              <svg [lucideIcon]="badge.icon" [size]="11"></svg>
            }
            {{ badge.label }}
          </span>
        }
      </div>
    } @else if (reservesBadges()) {
      <div class="v3-content-card__badges v3-content-card__row--reserved" aria-hidden="true"></div>
    }

    <h3 class="v3-content-card__title" [class.is-placeholder]="item().titleIsPlaceholder">{{ item().title }}</h3>

    @if (item().subtitle) {
      <div class="v3-content-card__subtitle">{{ item().subtitle }}</div>
    } @else if (reservesSubtitle()) {
      <div class="v3-content-card__subtitle v3-content-card__row--reserved" aria-hidden="true"></div>
    }

    @if (showMetaRow()) {
      <div class="v3-content-card__meta">
        @if (overdueInList(); as badge) {
          <span class="v3-content-card__meta-badge" data-tone="danger">{{ badge.text }}</span>
        }
        @for (entry of metaEntries(); track $index) {
          <span class="v3-content-card__meta-item">
            @if (entry.icon) {
              <svg [lucideIcon]="entry.icon" [size]="11"></svg>
            }
            {{ entry.text }}
          </span>
        }
        @if (metaBadge(); as badge) {
          <span class="v3-content-card__meta-badge" [attr.data-tone]="badge.tone">
            @if (badge.icon) {
              <svg [lucideIcon]="badge.icon" [size]="11"></svg>
            }
            {{ badge.label }}
          </span>
        }
      </div>
    } @else if (reservesMeta()) {
      <div class="v3-content-card__meta v3-content-card__row--reserved" aria-hidden="true"></div>
    }

    @if (showTagRow()) {
      <div class="v3-content-card__tags">
        @for (tag of tags().slice(0, 2); track $index) {
          <span class="v3-content-card__tag">{{ tag }}</span>
        }
      </div>
    } @else if (reservesTags()) {
      <div class="v3-content-card__tags v3-content-card__row--reserved" aria-hidden="true"></div>
    }

    @if (!compact()) {
      @if (gradeLabel(); as grade) {
        <div class="v3-content-card__progress v3-content-card__grade">
          <span
            class="v3-content-card__grade-pill"
            [class.v3-content-card__grade-pill--pass]="gradePassing()"
            [class.v3-content-card__grade-pill--fail]="!gradePassing()"
          >
            <svg [lucideIcon]="gradeIcon()" [size]="12"></svg>
            {{ grade }}
          </span>
        </div>
      } @else if (hasProgress()) {
        <div class="v3-content-card__progress">
          <div class="v3-content-card__progress-bar-bg">
            <div class="v3-content-card__progress-bar-fill" [style.width.%]="progressValue()"></div>
          </div>
          <span class="v3-content-card__progress-text">{{ progressValue() }}%{{ progressSuffix() }}</span>
        </div>
      } @else if (reservesProgress()) {
        <div class="v3-content-card__progress v3-content-card__row--reserved" aria-hidden="true"></div>
      }
    }
  </div>
</article>
